import { isManifest } from './protocol';

/** The server owns admission policy so reopening guest access needs no client rebuild. */
export async function sharedCityRequiresAccount(): Promise<boolean> {
  const response = await fetch('/api/worlds/amsterdam1538/', { credentials: 'same-origin' });
  if (!response.ok) throw new Error('The shared city is unavailable. Try again.');
  const manifest: unknown = await response.json();
  if (!isManifest(manifest)) throw new Error('The shared city is unavailable. Try again.');
  return manifest.requires_account;
}
